import { parse } from 'yaml';

import adminEnYaml from './locales/en/admin.yaml?raw';
import authEnYaml from './locales/en/auth.yaml?raw';
import commonEnYaml from './locales/en/common.yaml?raw';
import healthEncyclopediaEnYaml from './locales/en/health-encyclopedia.yaml?raw';
import counselingManualEnYaml from './locales/en/counseling-manual.yaml?raw';
import managementGuidelinesEnYaml from './locales/en/management-guidelines.yaml?raw';
import medicalEnYaml from './locales/en/medical.yaml?raw';
import myProfileEnYaml from './locales/en/my-profile.yaml?raw';
import proItemDesignEnYaml from './locales/en/pro-item-design.yaml?raw';
import questionnaireDesignEnYaml from './locales/en/questionnaire-design.yaml?raw';
import proDeploymentEnYaml from './locales/en/pro-deployment.yaml?raw';
import noticesEnYaml from './locales/en/notices.yaml?raw';
import notificationSettingsEnYaml from './locales/en/notification-settings.yaml?raw';
import rolesEnYaml from './locales/en/roles.yaml?raw';
import termsEnYaml from './locales/en/terms.yaml?raw';
import validationEnYaml from './locales/en/validation.yaml?raw';

import adminKoYaml from './locales/ko/admin.yaml?raw';
import authKoYaml from './locales/ko/auth.yaml?raw';
import commonKoYaml from './locales/ko/common.yaml?raw';
import healthEncyclopediaKoYaml from './locales/ko/health-encyclopedia.yaml?raw';
import counselingManualKoYaml from './locales/ko/counseling-manual.yaml?raw';
import managementGuidelinesKoYaml from './locales/ko/management-guidelines.yaml?raw';
import medicalKoYaml from './locales/ko/medical.yaml?raw';
import myProfileKoYaml from './locales/ko/my-profile.yaml?raw';
import proItemDesignKoYaml from './locales/ko/pro-item-design.yaml?raw';
import questionnaireDesignKoYaml from './locales/ko/questionnaire-design.yaml?raw';
import proDeploymentKoYaml from './locales/ko/pro-deployment.yaml?raw';
import noticesKoYaml from './locales/ko/notices.yaml?raw';
import notificationSettingsKoYaml from './locales/ko/notification-settings.yaml?raw';
import rolesKoYaml from './locales/ko/roles.yaml?raw';
import termsKoYaml from './locales/ko/terms.yaml?raw';
import validationKoYaml from './locales/ko/validation.yaml?raw';

type LocaleResource = Record<string, unknown>;

const readLocale = (source: string): LocaleResource => parse(source) as LocaleResource;

export const resources = {
  en: {
    admin: readLocale(adminEnYaml),
    auth: readLocale(authEnYaml),
    common: readLocale(commonEnYaml),
    'health-encyclopedia': readLocale(healthEncyclopediaEnYaml),
    'counseling-manual': readLocale(counselingManualEnYaml),
    'management-guidelines': readLocale(managementGuidelinesEnYaml),
    medical: readLocale(medicalEnYaml),
    'my-profile': readLocale(myProfileEnYaml),
    'pro-item-design': readLocale(proItemDesignEnYaml),
    'questionnaire-design': readLocale(questionnaireDesignEnYaml),
    'pro-deployment': readLocale(proDeploymentEnYaml),
    notices: readLocale(noticesEnYaml),
    'notification-settings': readLocale(notificationSettingsEnYaml),
    roles: readLocale(rolesEnYaml),
    terms: readLocale(termsEnYaml),
    validation: readLocale(validationEnYaml),
  },
  ko: {
    admin: readLocale(adminKoYaml),
    auth: readLocale(authKoYaml),
    common: readLocale(commonKoYaml),
    'health-encyclopedia': readLocale(healthEncyclopediaKoYaml),
    'counseling-manual': readLocale(counselingManualKoYaml),
    'management-guidelines': readLocale(managementGuidelinesKoYaml),
    medical: readLocale(medicalKoYaml),
    'my-profile': readLocale(myProfileKoYaml),
    'pro-item-design': readLocale(proItemDesignKoYaml),
    'questionnaire-design': readLocale(questionnaireDesignKoYaml),
    'pro-deployment': readLocale(proDeploymentKoYaml),
    notices: readLocale(noticesKoYaml),
    'notification-settings': readLocale(notificationSettingsKoYaml),
    roles: readLocale(rolesKoYaml),
    terms: readLocale(termsKoYaml),
    validation: readLocale(validationKoYaml),
  },
} as const;
